export var typeOptions = [{
  label: '开屏广告',
  value: 1,
  tag: 'gray'
}, {
  label: '插屏广告',
  value: 2,
  tag: 'blue'
}, {
  label: '信息流广告',
  value: 3,
  tag: 'orange'
}, {
  label: '激励视频广告',
  value: 4,
  tag: 'red'
}, {
  label: 'Banner广告',
  value: 5,
  tag: 'cyan'
}, {
  label: '视频信息流广告',
  value: 6,
  tag: 'green'
}];
export var platformOptions = [{
  label: '微信小程序',
  value: 1,
  tag: 'green'
}, {
  label: '国内Android',
  value: 2,
  tag: 'cyan'
}, {
  label: '国内iOS',
  value: 3,
  tag: 'orange'
}
// { label: '支付宝小程序', value: 2, tag: 'blue' },
// { label: '抖音小程序', value: 3, tag: 'gray' },
// { label: '百度小程序', value: 4, tag: 'blue' },
// { label: 'QQ小程序', value: 5, tag: 'red' },
];
export var outPlatformOptions = [{
  label: '微信小程序',
  value: 1,
  tag: 'green'
}, {
  label: '激活鸟',
  value: 2,
  tag: 'blue'
}, {
  label: 'uni广告',
  value: 3,
  tag: 'orange'
}, {
  label: 'Gromore-影腾智联APP',
  value: 4,
  tag: 'cyan'
}];
export var defaultFormData = {
  id: '',
  adName: '',
  platform: '',
  // wechatAppId: '',
  // wechatAppKey: '',
  adType: '',
  status: 1,
  remark: ''
};
export var formRules = {
  adName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入广告名称'
  }],
  platform: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择平台'
  }],
  adType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择广告类型'
  }],
  status: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择状态'
  }]
};
export var defaultFormCodeData = {
  id: '',
  applicationId: '',
  miniAppName: '',
  adsSlotId: '',
  outPlatform: '',
  codeName: '',
  codeId: '',
  status: 1,
  remark: ''
};
export var formCodeRules = {
  appId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择所属应用'
  }],
  codeName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入代码位名称'
  }],
  outPlatform: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择广告商'
  }],
  codeId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入代码ID'
  }],
  status: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择状态'
  }]
};